import React from 'react';
import { FeatureAppModelConfig } from '../typing/main';
import { useSafeContext } from './use-safe-context';

export const ModelsConfigContext = React.createContext<
  FeatureAppModelConfig | undefined
>(undefined);

export function useModelsConfig(): FeatureAppModelConfig {
  const modelsConfig = useSafeContext(ModelsConfigContext, "models config");

  return modelsConfig;
}
